import { Grid as MuiGrid, GridProps } from '@mui/material';

const Grid = ({ ...rest }: GridProps) => <MuiGrid {...rest} />;

export default Grid;
